import { BlockMeetingContent } from 'store/states/lessons.state'
import { BlockTypes } from 'enum'
import api from '../..'

export const getMeetingBlock = (blockId: number) => {
  return api.get(`block_meeting/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }): BlockMeetingContent => {
      const {
        id,
        config,
        description,
        duration,
        integrationType,
        response,
        startTime,
        title,
        typeMeet,
        blockInstanceId,
        userId,
        invitation
      } = attributes
      return {
        id,
        blockInstanceId,
        config,
        description,
        duration,
        integrationType,
        response,
        startTime,
        title,
        typeMeet,
        type: BlockTypes.BlockMeeting,
        userId,
        invitation
      } as BlockMeetingContent
    }
  )
}
